import {
  asosGlobalNamespace,
  audiencesSdkGlobalNamespace,
  sdkGlobalNamespace
} from "@template/constants";
import clientConfig from "@template/clientConfig";
import { noticeError } from "@src/helpers/monitoring";
import getFeature from "@template/helpers/getFeature";
import sdkInstanceProvider from "../sdk/sdkInstanceProvider";

export const getLoyaltyInvitedStatus = async () => {
  const { LOYALTY_SEGMENT_ID } = clientConfig.get();

  const { isEnabled: isInviteAllUsersToLoyaltyFeatureEnabled } =
    await getFeature("loyalty_invite_all_eligible_users");

  if (isInviteAllUsersToLoyaltyFeatureEnabled()) {
    return true;
  }

  const identitySdk = await sdkInstanceProvider("identity");
  const isLoggedIn = await identitySdk.customer.isAuthenticated();

  if (!isLoggedIn) {
    return false;
  }

  let segments = [];

  try {
    segments =
      await window[asosGlobalNamespace][sdkGlobalNamespace][
        audiencesSdkGlobalNamespace
      ].getSegments();
  } catch (error) {
    noticeError(error);
    return false;
  }

  const isInvited = segments.some(
    ({ segmentId }) => segmentId === LOYALTY_SEGMENT_ID
  );

  return isInvited;
};
